export const TRANSLATIONS = {
  lt: {
    app_name: "StopChlamas",
    tagline: "Stop chlamas. Visa Lietuva valo garažus.",
    hero_sub: "Skelbimų platforma įrankiams, auto detalėms, sodo technikai ir visam tam, kas slypi tavo garaže. Vieta, kur viskas viename – visai Lietuvai.",
    cta_browse: "Naršyti skelbimus",
    cta_post: "Įkelti skelbimą",
    cta_login: "Prisijungti",
    cta_logout: "Atsijungti",
    nav_home: "Pagrindinis",
    nav_browse: "Skelbimai",
    nav_post: "Įkelti",
    nav_messages: "Žinutės",
    nav_alerts: "Pranešimai",
    nav_profile: "Profilis",
    search_placeholder: "Ieškau drelės, padangų, žoliapjovės...",
    category: "Kategorija",
    city: "Miestas",
    price: "Kaina",
    type: "Tipas",
    all_categories: "Visos kategorijos",
    all_cities: "Visi miestai",
    all_types: "Visi tipai",
    title: "Pavadinimas",
    description: "Aprašymas",
    images: "Nuotraukos",
    upload_images: "Įkelti nuotraukas (iki 6)",
    ai_autofill: "✨ Užpildyti su AI",
    ai_autofill_hint: "Įkelk nuotrauką ir leisk AI pasiūlyti pavadinimą, aprašymą, kategoriją ir kainą",
    ai_analyzing: "AI analizuoja nuotrauką...",
    ai_filled: "Užpildyta su AI – patikrink ir publikuok",
    ai_failed: "Nepavyko atpažinti nuotraukos. Užpildyk rankiniu būdu.",
    ai_low_conf: "AI nelabai užtikrintas. Pasitikrink ir pakoreguok laukus.",
    publish: "Publikuoti",
    listing_fee_note: "Pirmas skelbimas – nemokamas. Nuo 2-o – 1 € per Stripe.",
    free_first: "Tavo 1-as skelbimas yra NEMOKAMAS",
    pay_continue: "Mokėti 1 € ir publikuoti",
    cancel: "Atšaukti",
    save: "Išsaugoti",
    delete: "Ištrinti",
    smart_alerts_title: "Išmanieji pranešimai",
    smart_alerts_sub: "Prenumeruok raktažodį – kai kas nors įkelia tokį skelbimą tavo mieste, gausi pranešimą iš karto.",
    tg_title: "Pranešimai į Telegram",
    tg_unlinked_desc: "Gauk pranešimus tiesiai į telefoną per @StopChlamasBot: ▸ naujus skelbimus pagal raktažodį ▸ žinutes apie tavo skelbimus ▸ aukcionų pabaigą ir naujus statymus ▸ naujus įvertinimus.",
    tg_linked_desc: "Susieta ✓ Pranešimai siunčiami į tavo Telegram: nauji skelbimai pagal raktažodį, žinutės, aukcionų atnaujinimai ir įvertinimai.",
    tg_status_linked: "Susieta",
    tg_connect: "Susieti Telegram",
    tg_disconnect: "Atjungti",
    tg_waiting: "Laukiama Telegram...",
    tg_connected: "Telegram sėkmingai susietas!",
    tg_disconnected: "Telegram atjungtas",
    push_title: "Naršyklės push pranešimai",
    push_desc_off: "Pridėk svetainę į ekraną (pagrindinio meniu) ir gauk pranešimus tiesiai į naršyklę / telefoną — net kai svetainė uždaryta.",
    push_desc_on: "Įjungta ✓ Gauni naršyklės/telefono push pranešimus apie tavo skelbimus ir naujus daiktus.",
    push_enable: "Įjungti pranešimus",
    push_disable: "Išjungti",
    push_status_on: "Įjungta",
    push_enabled: "Pranešimai įjungti ✓",
    push_disabled: "Pranešimai išjungti",
    push_failed: "Nepavyko įjungti pranešimų",
    add_alert: "Pridėti raktažodį",
    keyword: "Raktažodis",
    your_alerts: "Mano raktažodžiai",
    your_listings: "Mano skelbimai",
    your_notifications: "Pranešimai",
    notifications_empty: "Kol kas pranešimų nėra.",
    listings_empty: "Kol kas skelbimų nėra.",
    place_bid: "Pasiūlyti",
    current_bid: "Aukščiausias pasiūlymas",
    starting_price: "Pradinė kaina",
    auction_ends: "Aukcionas baigiasi po",
    auction_ended: "Aukcionas baigėsi",
    seller: "Pardavėjas",
    contact_seller: "Susisiekti su pardavėju",
    your_message: "Tavo žinutė",
    send: "Siųsti",
    rate_user: "Įvertinti vartotoją",
    write_review: "Parašyk atsiliepimą...",
    submit_rating: "Pateikti įvertinimą",
    average_rating: "Vidutinis įvertinimas",
    reviews: "atsiliepimų",
    no_messages: "Žinučių nėra",
    free_section_title: "Atiduodu / Mainau",
    free_section_sub: "Daiktai už ačiū arba mainai į kavą. Nemokamų daiktų sekcija.",
    auctions_title: "24h Aukcionai",
    auctions_sub: "Kas pasiūlys daugiau iki vakaro – tas pasiima.",
    nearby_title: "Garažo kaimynystė",
    nearby_sub: "Pamatyk, ką parduoda kaimynai tavo mieste.",
    login_required: "Reikia prisijungti",
    free: "Nemokamai",
    photos: "nuotraukos",
    days: "d.", hours: "val.", minutes: "min.", seconds: "sek.",
    select_city: "Pasirink miestą",
    select_category: "Pasirink kategoriją",
    select_type: "Pasirink tipą",
    payment_processing: "Mokėjimas apdorojamas...",
    payment_success: "Mokėjimas sėkmingas!",
    payment_failed: "Mokėjimas nepavyko",
    listing_active: "Tavo skelbimas dabar aktyvus.",
    pending_payment: "Laukia mokėjimo",
    inactive: "Neaktyvus",
    active: "Aktyvus",
    payment: "Sumokėti 1 €",
    pay_to_activate: "Sumokėk 1 €, kad skelbimas būtų aktyvus",
    type_sell: "Parduodu",
    type_free: "Atiduodu",
    type_trade: "Mainau",
    type_auction: "Aukcionas 24h",
    new_listing: "Naujas skelbimas",
    explore_categories: "Naršyti kategorijas",
    hot_now: "Šiuo metu populiaru",
    posted_by: "Įkėlė",
    chat: "Pokalbis",
    type_message: "Rašyk žinutę...",
    no_results: "Nieko nerasta",
    try_other: "Pabandyk kitus filtrus arba užsiprenumeruok raktažodį.",
    search_nationwide: "Ieškoti visoje Lietuvoje",
    no_city_listings: "Tavo mieste dar nieko nėra. Pažiūrėk, kas yra kituose miestuose:",
    search: "Ieškoti",
    rating_thanks: "Ačiū už įvertinimą!",
    alert_added: "Raktažodis užregistruotas. Lauk pranešimo!",
    alert_match: "Naujas skelbimas pagal tavo raktažodį",
    alert_match_msg: "Nauja žinutė!",
    click_to_open: "Spausk, kad atidarytum",
    distance_title: "Mano miestas",
    distance_sub: "Filtruok skelbimus pagal savo miestą – kaimynystės principu.",
    edit_listing: "Redaguoti skelbimą",
    footer_legal: "Teisinė informacija",
    footer_terms: "Naudojimosi sąlygos",
    footer_privacy: "Privatumo politika",
    footer_contact: "Kontaktai",
    footer_about: "Apie",
    footer_about_link: "Apie mus",
    footer_rights: "Visos teisės saugomos",
    footer_made_in: "Sukurta Lietuvoje",
    footer_popular_cities: "Populiarūs miestai",
    footer_popular_categories: "Populiarios kategorijos",
    legal_last_updated: "Atnaujinta",
    contact_title: "Kontaktai",
    contact_intro: "Turi klausimų, pasiūlymų ar pranešimų apie netinkamą turinį? Susisiek su mumis.",
    contact_email: "El. paštas",
    contact_response: "Stengiamės atsakyti per 48 valandas.",
    contact_form_name: "Vardas",
    contact_form_email: "Tavo el. paštas",
    contact_form_message: "Žinutė",
    contact_form_send: "Siųsti žinutę",
    contact_sent: "Žinutė išsiųsta. Ačiū!",
    inapp_warning_title: "Atrodo, atidarei iš programėlės",
    inapp_warning_body: "Google saugumo sumetimais blokuoja prisijungimą per Facebook / Instagram / Messenger naršykles. Atidaryk svetainę Safari ar Chrome — arba užsiregistruok el. paštu (veikia visur).",
    open_in_browser: "Atidaryti naršyklėje",
    forgot_password: "Pamiršai slaptažodį?",
    forgot_password_title: "Pamiršai slaptažodį?",
    forgot_password_sub: "Įvesk savo el. paštą — atsiųsim nuorodą, kad nustatytum naują slaptažodį.",
    forgot_password_email_label: "El. paštas",
    forgot_password_submit: "Siųsti nuorodą",
    forgot_password_sent_title: "Tikrink savo paštą",
    forgot_password_sent_sub: "Jei tokia paskyra egzistuoja, ką tik išsiuntėme atstatymo nuorodą. Nuoroda galioja 1 valandą.",
    forgot_password_back: "Grįžti į prisijungimą",
    reset_password_title: "Nustatyk naują slaptažodį",
    reset_password_sub: "Įvesk naują slaptažodį (bent 6 simboliai).",
    reset_password_new: "Naujas slaptažodis",
    reset_password_confirm: "Pakartok slaptažodį",
    reset_password_submit: "Pakeisti slaptažodį",
    reset_password_mismatch: "Slaptažodžiai nesutampa",
    reset_password_too_short: "Slaptažodis per trumpas (bent 6 simboliai)",
    reset_password_invalid_token: "Nuoroda netinkama arba pasibaigusi. Bandyk dar kartą.",
    reset_password_success: "Slaptažodis pakeistas. Dabar prisijunk su nauju slaptažodžiu.",
  },
  ru: {
    app_name: "StopChlamas",
    tagline: "Стоп хламу. Вся Литва чистит гаражи.",
    hero_sub: "Площадка объявлений для инструментов, автозапчастей, садовой техники и всего, что лежит в гараже. Всё в одном месте — для всей Литвы.",
    cta_browse: "Смотреть объявления",
    cta_post: "Подать объявление",
    cta_login: "Войти",
    cta_logout: "Выйти",
    nav_home: "Главная",
    nav_browse: "Объявления",
    nav_post: "Добавить",
    nav_messages: "Сообщения",
    nav_alerts: "Уведомления",
    nav_profile: "Профиль",
    search_placeholder: "Ищу дрель, шины, газонокосилку...",
    category: "Категория",
    city: "Город",
    price: "Цена",
    type: "Тип",
    all_categories: "Все категории",
    all_cities: "Все города",
    all_types: "Все типы",
    title: "Название",
    description: "Описание",
    images: "Фотографии",
    upload_images: "Загрузить фото (до 6)",
    ai_autofill: "✨ Заполнить с AI",
    ai_autofill_hint: "Загрузи фото — AI предложит название, описание, категорию и цену",
    ai_analyzing: "AI анализирует фото...",
    ai_filled: "Заполнено с AI — проверь и опубликуй",
    ai_failed: "Не удалось распознать фото. Заполни вручную.",
    ai_low_conf: "AI не очень уверен. Проверь и подправь поля.",
    publish: "Опубликовать",
    listing_fee_note: "1-е объявление бесплатно. Со 2-го — 1 € через Stripe.",
    free_first: "Твоё 1-е объявление БЕСПЛАТНО",
    pay_continue: "Оплатить 1 € и опубликовать",
    cancel: "Отмена",
    save: "Сохранить",
    delete: "Удалить",
    smart_alerts_title: "Умные уведомления",
    smart_alerts_sub: "Подпишись на ключевое слово — получишь уведомление, как только в твоём городе кто-то выложит такой товар.",
    tg_title: "Уведомления в Telegram",
    tg_unlinked_desc: "Получай уведомления прямо в телефон через @StopChlamasBot: ▸ новые объявления по ключевому слову ▸ сообщения о твоих объявлениях ▸ окончание аукционов и новые ставки ▸ новые отзывы.",
    tg_linked_desc: "Подключено ✓ Уведомления приходят в твой Telegram: новые объявления, сообщения, обновления аукциона и отзывы.",
    tg_status_linked: "Подключено",
    tg_connect: "Подключить Telegram",
    tg_disconnect: "Отключить",
    tg_waiting: "Ожидание Telegram...",
    tg_connected: "Telegram успешно подключён!",
    tg_disconnected: "Telegram отключён",
    push_title: "Push-уведомления в браузере",
    push_desc_off: "Добавь сайт на экран (главное меню) и получай уведомления прямо в браузер / телефон — даже когда сайт закрыт.",
    push_desc_on: "Включено ✓ Получаешь push-уведомления в браузере/телефоне о своих объявлениях.",
    push_enable: "Включить уведомления",
    push_disable: "Отключить",
    push_status_on: "Включено",
    push_enabled: "Уведомления включены ✓",
    push_disabled: "Уведомления отключены",
    push_failed: "Не удалось включить уведомления",
    add_alert: "Добавить ключевое слово",
    keyword: "Ключевое слово",
    your_alerts: "Мои подписки",
    your_listings: "Мои объявления",
    your_notifications: "Уведомления",
    notifications_empty: "Пока нет уведомлений.",
    listings_empty: "Объявлений пока нет.",
    place_bid: "Сделать ставку",
    current_bid: "Высшая ставка",
    starting_price: "Стартовая цена",
    auction_ends: "Аукцион заканчивается через",
    auction_ended: "Аукцион завершён",
    seller: "Продавец",
    contact_seller: "Связаться с продавцом",
    your_message: "Твоё сообщение",
    send: "Отправить",
    rate_user: "Оценить пользователя",
    write_review: "Напиши отзыв...",
    submit_rating: "Отправить отзыв",
    average_rating: "Средний рейтинг",
    reviews: "отзывов",
    no_messages: "Нет сообщений",
    free_section_title: "Отдаю / Меняю",
    free_section_sub: "Вещи даром или обмен на кофе. Раздел бесплатных вещей.",
    auctions_title: "Аукционы 24ч",
    auctions_sub: "Кто предложит больше до вечера — тот забирает.",
    nearby_title: "Гаражный квартал",
    nearby_sub: "Посмотри, что продают соседи в твоём городе.",
    login_required: "Нужно войти",
    free: "Бесплатно",
    photos: "фото",
    days: "дн.", hours: "ч.", minutes: "мин.", seconds: "сек.",
    select_city: "Выбери город",
    select_category: "Выбери категорию",
    select_type: "Выбери тип",
    payment_processing: "Платёж обрабатывается...",
    payment_success: "Платёж успешен!",
    payment_failed: "Платёж не прошёл",
    listing_active: "Твоё объявление теперь активно.",
    pending_payment: "Ожидает оплаты",
    inactive: "Неактивно",
    active: "Активно",
    payment: "Оплатить 1 €",
    pay_to_activate: "Оплати 1 €, чтобы объявление стало активным",
    type_sell: "Продаю",
    type_free: "Отдаю",
    type_trade: "Меняю",
    type_auction: "Аукцион 24ч",
    new_listing: "Новое объявление",
    explore_categories: "Категории",
    hot_now: "Сейчас популярно",
    posted_by: "Подал",
    chat: "Чат",
    type_message: "Напиши сообщение...",
    no_results: "Ничего не найдено",
    try_other: "Попробуй другие фильтры или подпишись на ключевое слово.",
    search_nationwide: "Искать по всей Литве",
    no_city_listings: "В твоём городе пока ничего нет. Посмотри, что есть в других городах:",
    search: "Поиск",
    rating_thanks: "Спасибо за оценку!",
    alert_added: "Ключевое слово сохранено. Жди уведомление!",
    alert_match: "Новое объявление по твоему ключевому слову",
    alert_match_msg: "Новое сообщение!",
    click_to_open: "Нажми, чтобы открыть",
    distance_title: "Мой город",
    distance_sub: "Фильтруй объявления по своему городу — по принципу соседства.",
    edit_listing: "Редактировать объявление",
    footer_legal: "Правовая информация",
    footer_terms: "Условия использования",
    footer_privacy: "Политика конфиденциальности",
    footer_contact: "Контакты",
    footer_about: "О нас",
    footer_about_link: "О проекте",
    footer_rights: "Все права защищены",
    footer_made_in: "Сделано в Литве",
    footer_popular_cities: "Популярные города",
    footer_popular_categories: "Популярные категории",
    legal_last_updated: "Обновлено",
    contact_title: "Контакты",
    contact_intro: "Есть вопросы, предложения или жалобы на контент? Напиши нам.",
    contact_email: "Эл. почта",
    contact_response: "Мы стараемся отвечать в течение 48 часов.",
    contact_form_name: "Имя",
    contact_form_email: "Твой эл. адрес",
    contact_form_message: "Сообщение",
    contact_form_send: "Отправить сообщение",
    contact_sent: "Сообщение отправлено. Спасибо!",
    inapp_warning_title: "Кажется, ты открыл из приложения",
    inapp_warning_body: "Google по соображениям безопасности блокирует вход через встроенные браузеры Facebook / Instagram / Messenger. Открой сайт в Safari или Chrome — либо зарегистрируйся по email (работает везде).",
    open_in_browser: "Открыть в браузере",
    forgot_password: "Забыл пароль?",
    forgot_password_title: "Забыл пароль?",
    forgot_password_sub: "Введи свой email — пришлём ссылку для установки нового пароля.",
    forgot_password_email_label: "Email",
    forgot_password_submit: "Отправить ссылку",
    forgot_password_sent_title: "Проверь свою почту",
    forgot_password_sent_sub: "Если такой аккаунт существует, мы только что отправили ссылку для сброса. Ссылка действует 1 час.",
    forgot_password_back: "Вернуться ко входу",
    reset_password_title: "Установи новый пароль",
    reset_password_sub: "Введи новый пароль (минимум 6 символов).",
    reset_password_new: "Новый пароль",
    reset_password_confirm: "Повтори пароль",
    reset_password_submit: "Сменить пароль",
    reset_password_mismatch: "Пароли не совпадают",
    reset_password_too_short: "Пароль слишком короткий (минимум 6 символов)",
    reset_password_invalid_token: "Ссылка недействительна или истекла. Попробуй ещё раз.",
    reset_password_success: "Пароль изменён. Войди с новым паролем.",
  },
  en: {
    app_name: "StopChlamas",
    tagline: "Stop the junk. All of Lithuania is cleaning out garages.",
    hero_sub: "Marketplace for tools, auto parts, garden equipment and all the stuff hiding in your garage. One place for all of Lithuania.",
    cta_browse: "Browse listings",
    cta_post: "Post listing",
    cta_login: "Sign in",
    cta_logout: "Sign out",
    nav_home: "Home",
    nav_browse: "Listings",
    nav_post: "Post",
    nav_messages: "Messages",
    nav_alerts: "Alerts",
    nav_profile: "Profile",
    search_placeholder: "Looking for a drill, tires, lawn mower...",
    category: "Category",
    city: "City",
    price: "Price",
    type: "Type",
    all_categories: "All categories",
    all_cities: "All cities",
    all_types: "All types",
    title: "Title",
    description: "Description",
    images: "Photos",
    upload_images: "Upload photos (up to 6)",
    ai_autofill: "✨ Auto-fill with AI",
    ai_autofill_hint: "Upload a photo and let AI suggest the title, description, category and price",
    ai_analyzing: "AI is analyzing the photo...",
    ai_filled: "Filled by AI — review and publish",
    ai_failed: "Could not recognize the photo. Please fill in manually.",
    ai_low_conf: "AI is not very confident. Please review and tweak the fields.",
    publish: "Publish",
    listing_fee_note: "Your 1st listing is free. From 2nd onwards — 1 € via Stripe.",
    free_first: "Your 1st listing is FREE",
    pay_continue: "Pay 1 € & publish",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    smart_alerts_title: "Smart Alerts",
    smart_alerts_sub: "Subscribe to a keyword — get instantly notified when someone posts a matching listing in your city.",
    tg_title: "Telegram notifications",
    tg_unlinked_desc: "Get push notifications via @StopChlamasBot: ▸ new listings matching your keyword ▸ messages about your listings ▸ auction endings & new bids ▸ new ratings.",
    tg_linked_desc: "Connected ✓ Notifications are sent to your Telegram: new listings, messages, auction updates and ratings.",
    tg_status_linked: "Connected",
    tg_connect: "Connect Telegram",
    tg_disconnect: "Disconnect",
    tg_waiting: "Waiting for Telegram...",
    tg_connected: "Telegram successfully connected!",
    tg_disconnected: "Telegram disconnected",
    push_title: "Browser push notifications",
    push_desc_off: "Add the site to your home screen and get push notifications straight to your browser / phone — even when the site is closed.",
    push_desc_on: "On ✓ You're receiving browser/phone push notifications about your listings.",
    push_enable: "Enable notifications",
    push_disable: "Disable",
    push_status_on: "On",
    push_enabled: "Notifications enabled ✓",
    push_disabled: "Notifications disabled",
    push_failed: "Could not enable notifications",
    add_alert: "Add keyword",
    keyword: "Keyword",
    your_alerts: "My alerts",
    your_listings: "My listings",
    your_notifications: "Notifications",
    notifications_empty: "No notifications yet.",
    listings_empty: "No listings yet.",
    place_bid: "Place bid",
    current_bid: "Highest bid",
    starting_price: "Starting price",
    auction_ends: "Auction ends in",
    auction_ended: "Auction ended",
    seller: "Seller",
    contact_seller: "Contact seller",
    your_message: "Your message",
    send: "Send",
    rate_user: "Rate user",
    write_review: "Write a review...",
    submit_rating: "Submit rating",
    average_rating: "Average rating",
    reviews: "reviews",
    no_messages: "No messages",
    free_section_title: "Give Away / Trade",
    free_section_sub: "Stuff for free or trade for coffee. The free items section.",
    auctions_title: "24h Auctions",
    auctions_sub: "Highest bid by tonight wins.",
    nearby_title: "Garage Neighborhood",
    nearby_sub: "See what your neighbors are selling in your city.",
    login_required: "Login required",
    free: "Free",
    photos: "photos",
    days: "d", hours: "h", minutes: "m", seconds: "s",
    select_city: "Select city",
    select_category: "Select category",
    select_type: "Select type",
    payment_processing: "Processing payment...",
    payment_success: "Payment successful!",
    payment_failed: "Payment failed",
    listing_active: "Your listing is now active.",
    pending_payment: "Pending payment",
    inactive: "Inactive",
    active: "Active",
    payment: "Pay 1 €",
    pay_to_activate: "Pay 1 € to activate this listing",
    type_sell: "Selling",
    type_free: "Free",
    type_trade: "Trade",
    type_auction: "Auction 24h",
    new_listing: "New listing",
    explore_categories: "Browse categories",
    hot_now: "Hot right now",
    posted_by: "Posted by",
    chat: "Chat",
    type_message: "Type a message...",
    no_results: "Nothing found",
    try_other: "Try different filters or subscribe to a keyword.",
    search_nationwide: "Search across Lithuania",
    no_city_listings: "Nothing in your city yet. See what's listed in other cities:",
    search: "Search",
    rating_thanks: "Thanks for your rating!",
    alert_added: "Keyword saved. Wait for the alert!",
    alert_match: "New listing matches your keyword",
    alert_match_msg: "New message!",
    click_to_open: "Click to open",
    distance_title: "My city",
    distance_sub: "Filter listings by your city — neighborhood-style.",
    edit_listing: "Edit listing",
    footer_legal: "Legal",
    footer_terms: "Terms of Service",
    footer_privacy: "Privacy Policy",
    footer_contact: "Contact",
    footer_about: "About",
    footer_about_link: "About us",
    footer_rights: "All rights reserved",
    footer_made_in: "Made in Lithuania",
    footer_popular_cities: "Popular cities",
    footer_popular_categories: "Popular categories",
    legal_last_updated: "Last updated",
    contact_title: "Contact",
    contact_intro: "Have questions, suggestions or want to report content? Get in touch.",
    contact_email: "Email",
    contact_response: "We aim to reply within 48 hours.",
    contact_form_name: "Name",
    contact_form_email: "Your email",
    contact_form_message: "Message",
    contact_form_send: "Send message",
    contact_sent: "Message sent. Thanks!",
    inapp_warning_title: "Looks like you opened this from an app",
    inapp_warning_body: "Google blocks sign-in from Facebook / Instagram / Messenger in-app browsers for security. Open the site in Safari or Chrome — or register with email (works everywhere).",
    open_in_browser: "Open in browser",
    forgot_password: "Forgot password?",
    forgot_password_title: "Forgot password?",
    forgot_password_sub: "Enter your email — we'll send a link to set a new password.",
    forgot_password_email_label: "Email",
    forgot_password_submit: "Send link",
    forgot_password_sent_title: "Check your inbox",
    forgot_password_sent_sub: "If that account exists, we just sent a reset link. The link expires in 1 hour.",
    forgot_password_back: "Back to login",
    reset_password_title: "Set a new password",
    reset_password_sub: "Enter your new password (at least 6 characters).",
    reset_password_new: "New password",
    reset_password_confirm: "Confirm password",
    reset_password_submit: "Change password",
    reset_password_mismatch: "Passwords don't match",
    reset_password_too_short: "Password too short (min 6 characters)",
    reset_password_invalid_token: "Link is invalid or expired. Please try again.",
    reset_password_success: "Password changed. Sign in with your new password.",
  },
};

export const LANGUAGES = [
  { code: "lt", label: "LT", name: "Lietuvių" },
  { code: "ru", label: "RU", name: "Русский" },
  { code: "en", label: "EN", name: "English" },
];
